module.exports = __webpack_public_path__ + "static/media/FILMM2022.d3bf4692.pdf";